import { pathJoin } from 'src/reducers/routing/utils'

export const createRouteMapEditRouteScheme = (prefix: string) => ({
  configuration: pathJoin(prefix)('configuration').chain,
})
